import React from "react";
import "./App.css";

const openIntercom = () => {
  const mensajes = [
    "Pensando en hacer crecer tu negocio de carga? en que podemos ayudarte?",
    "Hola, estamos para ayudarte a crecer, en que podemos ayudarte?",
    "Estamos para hacerte crecer, como podemos ayudarte?",
    "Preguntas? Estamos aquí para ayudarte.",
    "Movemos tu carga y tu negocio adelante, en que podemos ayudarte?",
    "Somos un equipo de profesionales a tu disposición, en que podemos ayudarte?",
    "Preguntas? En que podemos ayudarte?"
  ];
  window.Intercom(
    "showNewMessage",
    mensajes[Math.floor(Math.random() * mensajes.length)]
  );
};
const App = () => (
  <div className="wraper">
    <div className="content">
      <a href="/" id="logo-liftit-cargo">
        <img src="/img/icon_liftit_logo.png" alt="Liftit Cargo" />
      </a>
      <header>
        <img src="/img/truck.png" alt="liftit truck" />
      </header>
      <div className="wraper-info">
        <h1>Tu carga y tu negocio, siempre hacia adelante.</h1>
        <button type="button" name="button" onClick={openIntercom}>
          Contacta Un Agente{" "}
          <span>
            <img src="/img/arrow-right.png" alt="" />
          </span>
        </button>
      </div>
    </div>
    <div className="footer">
      <p>
        A product designed and developed by<img
          src="/img/icon_alien.png"
          alt="Aliens"
        />Aliens at Liftit S.A.S. <span>©2017 All rights reserved.</span>
      </p>
    </div>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js